import { FormikProps, getIn } from "formik";
import { FC } from "react";
import CurrencyPicker from "components/core/currency-picker";
import { Currencies } from "_graphql/data";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { TextInput } from "components/core"; // Assuming TextInput handles label, input, and errors

export interface UpdateTargetRateFormValues {
  rate_value: number;
  currency_code: string;
  currency: string;
  rateId: string;
}

export interface UpdateTargetRateFormProps {
  form: FormikProps<UpdateTargetRateFormValues>;
}

const UpdateTargetRateForm: FC<UpdateTargetRateFormProps> = ({ form }) => {
  // getFieldError might not be needed if TextInput handles errors internally
  // const getFieldError = (fieldName: string) => {
  //   const touched = getIn(form.touched, fieldName);
  //   const error = getIn(form.errors, fieldName);
  //   return touched && error ? error : null;
  // };

  return (
    <div className="space-y-6 py-4"> {/* Increased spacing */}
      {/* Enhanced Alert Box */}
      <div
        className="bg-blue-50 border border-blue-300 text-blue-800 px-4 py-3 rounded-lg flex items-start space-x-3"
        role="alert"
      >
        <InformationCircleIcon className="h-5 w-5 text-blue-500 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-sm font-semibold">Rate Update Information</h3>
          <p className="text-sm">Update the rate value and currency information for this target.</p>
        </div>
      </div>

      {/* Form Fields */}
      <div className="space-y-5">
        {/* Using TextInput for consistency and potentially better error handling */}
        <TextInput
          label="Rate Value"
          id="rate_value"
          type="number"
          placeholder="0.00"
          {...form}
          min={0}
          step={0.01}
        />

        {/* Currency Picker - Assuming its styling is consistent */}
        <CurrencyPicker
          label="Currency"
          id="currency_code"
          values={form.values}
          errors={form.errors}
          touched={form.touched}
          setFieldValue={(field: string, value: string) => {
            form.setFieldValue(field, value); // Set currency_code

            // Automatically set the currency name based on the selected code
            const currencyObj = Currencies.find(
              (currency) => currency.code === value
            );
            if (currencyObj) {
              form.setFieldValue("currency", currencyObj.name_plural);
            } else {
              form.setFieldValue("currency", ""); // Clear name if code is invalid/not found
            }
          }}
          setFieldTouched={form.setFieldTouched}
          setFieldError={form.setFieldError} // Pass error setter if needed by CurrencyPicker
          placeholder="Select currency"
        />
      </div>
    </div>
  );
};

export default UpdateTargetRateForm;
